import React from 'react';
import { FormattedMessage } from 'react-intl';
import { staticLocale } from '../../../utils/useDateLocale';
import messages from './messages';

function labelRaces(count) {
  return (
    count && (
      <FormattedMessage key="n" {...messages.nRaces} values={{ count }} />
    )
  );
}

export function getProfile(data) {
  const { nRoutes, profile, strava, created } = data;
  const result = [];
  if (created) {
    result.push({
      key: 'created',
      value: new Date(created).toLocaleString(staticLocale.locale.code, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }),
    });
  }
  if (nRoutes) {
    if (data.nPublic) {
      result.push({
        key: 'nRoutes',
        value: (
          <>
            {nRoutes}
            <FormattedMessage
              key="nPublic"
              {...messages.nPublic}
              values={{ count: data.nPublic }} />
          </>
        ),
      });
    } else {
      result.push({ key: 'nRoutes', value: nRoutes });
    }
  }
  if (profile) {
    const { name, sex, yob, club, kmvRuns } = profile;
    const value = [name || <FormattedMessage key="p" {...messages.private} />];
    if (sex) {
      value.push([' (', <FormattedMessage key="s" {...messages[sex]} />, ')']);
    }
    if (yob) {
      value.push([', ', yob]);
    }
    if (club) {
      value.push([', ', club]);
    }
    if (kmvRuns) {
      value.push([', ', labelRaces(kmvRuns)]);
    }
    result.push({ key: 'kmvProfile', value });
  }
  if (strava) {
    const { firstname, lastname, sex, vRaces } = strava;
    const value = [`${firstname} ${lastname}`];
    if (sex) {
      value.push([
        ' (',
        <FormattedMessage key="sex" {...messages[sex]} />,
        ')',
      ]);
    }
    if (vRaces) {
      value.push([', ', labelRaces(vRaces)]);
    }
    result.push({ key: 'stravaProfile', value });
  }
  return result;
}
